module.exports = __webpack_public_path__ + "img/key.10693a37.svg";